// extracted by mini-css-extract-plugin
module.exports = {"Over18Message":"Over18Message_Over18Message__93UXZ","Buttons":"Over18Message_Buttons__1zYyG","Agree":"Over18Message_Agree__9nSIf","Disagree":"Over18Message_Disagree__3RDQO"};